import { computed } from "vue";
import { usePrimeVue } from "primevue/config";
import { useThemeStore } from "@/stores/theme";

export function useTheme() {
  const themeStore = useThemeStore();
  const PrimeVue = usePrimeVue();

  const currentTheme = computed(() => themeStore.currentTheme);
  const isDark = computed(() => themeStore.currentTheme === "dark");

  function toggleTheme() {
    const from = themeStore.currentTheme;
    const to = from === "dark" ? "light" : "dark";
    themeStore.switchTheme();
    PrimeVue.changeTheme(from, to, "theme-link", () => {});
  }

  const inputStyle = computed(() =>
    isDark.value
      ? {
          background: "#333",
          borderColor: "#333",
          boxShadow: "none",
          color: "#e0e0e0",
        }
      : {
          background: "rgba(255,255,255,0.47)",
          borderColor: "transparent",
          boxShadow: "none",
          color: "#292929",
        }
  );

  return { currentTheme, isDark, toggleTheme, inputStyle };
}
